import React from 'react';
import './TermsConditions.css';

function TermsConditions() {
  return (
    <div className="policy-container terms-conditions">
      <div className="policy-header">
        <h1>📋 Terms & Conditions</h1>
        <p className="last-updated">Last Updated: January 8, 2026</p>
      </div>

      <div className="policy-content">
        <section className="policy-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using this website (hereinafter "the Site"), you accept and agree to be bound by 
            the terms and provision of this agreement. If you do not agree to abide by the above, 
            please do not use this service.
          </p>
          <p>
            These Terms & Conditions apply to all users of the Site, including without limitation, 
            customers, vendors, and administrative users.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily download one copy of the materials (information or software) 
            on the Site for personal, non-commercial transitory viewing only. This is the grant of a license, 
            not a transfer of title, and under this license you may not:
          </p>
          <ul>
            <li>Modifying or copying the materials</li>
            <li>Using the materials for any commercial purpose, or for any public display (commercial or non-commercial)</li>
            <li>Attempting to decompile or reverse engineer any software contained on the Site</li>
            <li>Removing any copyright or other proprietary notations from the materials</li>
            <li>Transferring the materials to another person or "mirroring" the materials on any other server</li>
            <li>Violating any applicable laws or regulations related to access to or use of the Site</li>
            <li>Harassing or causing distress or inconvenience to any person</li>
            <li>Obscene or abusive language</li>
            <li>Disrupting the normal flow of dialogue within the Site</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Disclaimer</h2>
          <p>
            The materials on the Site are provided on an 'as is' basis. The Site makes no warranties, 
            expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, 
            implied warranties or conditions of merchantability, fitness for a particular purpose, 
            or non-infringement of intellectual property or other violation of rights.
          </p>
          <p>
            Further, the Site does not warrant or make any representations concerning the accuracy, 
            likely results, or reliability of the use of the materials on its Site or otherwise 
            relating to such materials or on any sites linked to this site.
          </p>
        </section>

        <section className="policy-section">
          <h2>4. Limitations of Liability</h2>
          <p>
            In no event shall the Site or its suppliers be liable for any damages (including, without limitation, 
            damages for loss of data or profit, or due to business interruption,) arising out of the use or 
            inability to use the materials on the Site, even if the Site or an authorized representative has 
            been notified orally or in writing of the possibility of such damage.
          </p>
          <p>
            Because some jurisdictions do not allow limitations on implied warranties, or limitations of 
            liability for consequential or incidental damages, these limitations may not apply to you.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Accuracy of Materials</h2>
          <p>
            The materials appearing on the Site could include technical, typographical, or photographic errors. 
            The Site does not warrant that any of the materials on the Site are accurate, complete, or current. 
            The Site may make changes to the materials contained on the Site at any time without notice.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Modifications to Terms</h2>
          <p>
            The Site may revise these terms of service for the Site at any time without notice. 
            By using this Site, you are agreeing to be bound by the then current version of these terms of service.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws of the 
            Republic of South Africa, and you irrevocably submit to the exclusive jurisdiction of the courts 
            located in South Africa.
          </p>
        </section>

        <section className="policy-section">
          <h2>8. User Accounts</h2>
          
          <div className="terms-subsection">
            <h3>8.1 Registration</h3>
            <p>
              To access certain features of the Site, you may be required to create an account. 
              You agree to provide accurate, current, and complete information during the registration process 
              and to update such information to keep it accurate, current, and complete.
            </p>
          </div>

          <div className="terms-subsection">
            <h3>8.2 Account Security</h3>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials, 
              including your password. You agree to accept responsibility for all activities that occur 
              under your account. If you suspect unauthorized use of your account, you must notify us immediately.
            </p>
          </div>

          <div className="terms-subsection">
            <h3>8.3 Account Termination</h3>
            <p>
              We reserve the right to terminate or suspend your account at any time, for any reason, 
              including but not limited to violation of these Terms & Conditions.
            </p>
          </div>
        </section>

        <section className="policy-section">
          <h2>9. Vendor Terms</h2>
          
          <div className="terms-subsection">
            <h3>9.1 Vendor Application</h3>
            <p>
              Prospective vendors must submit an application and agree to our vendor terms before 
              they are permitted to sell products on the Site. We reserve the right to accept or reject 
              any vendor application at our sole discretion.
            </p>
          </div>

          <div className="terms-subsection">
            <h3>9.2 Product Authenticity</h3>
            <p>
              Vendors warrant that all products listed for sale are authentic, of high quality, 
              and accurately described. Vendors are solely responsible for the authenticity and quality 
              of their products. We reserve the right to remove any product that we determine, in our sole discretion, 
              to be inauthentic, counterfeit, or misrepresented.
            </p>
          </div>

          <div className="terms-subsection">
            <h3>9.3 Compliance with Laws</h3>
            <p>
              Vendors agree to comply with all applicable South African laws and regulations, 
              including but not limited to the Consumer Protection Act, the National Credit Act, 
              and the Protection of Personal Information Act (POPIA).
            </p>
          </div>

          <div className="terms-subsection">
            <h3>9.4 Commission and Fees</h3>
            <p>
              Vendors agree to pay applicable commission rates and fees as specified by the Site. 
              These rates may change at any time upon notice. Vendors remain responsible for their own taxes, 
              duties, and other financial obligations.
            </p>
          </div>

          <div className="terms-subsection">
            <h3>9.5 Product Liability</h3>
            <p>
              Vendors are solely responsible for any liability arising from the manufacture, distribution, 
              or sale of their products, including product liability claims, injuries, or property damage. 
              Vendors agree to maintain adequate insurance coverage.
            </p>
          </div>
        </section>

        <section className="policy-section">
          <h2>10. Customer Terms</h2>
          
          <div className="terms-subsection">
            <h3>10.1 Purchases</h3>
            <p>
              When you purchase a product on the Site, you are entering into a contract with the vendor 
              of that product. Your purchase is subject to the vendor's acceptance of your order.
            </p>
          </div>

          <div className="terms-subsection">
            <h3>10.2 Pricing</h3>
            <p>
              All prices are subject to change without notice. The price of a product is as displayed 
              at the time of your order. We are not responsible for any typographical or pricing errors.
            </p>
          </div>

          <div className="terms-subsection">
            <h3>10.3 Returns and Refunds</h3>
            <p>
              Returns and refund policies are determined by individual vendors. Please review the 
              vendor's return policy before making a purchase. The Site is not responsible for enforcing 
              vendor return policies or processing refunds.
            </p>
          </div>

          <div className="terms-subsection">
            <h3>10.4 Product Information</h3>
            <p>
              The Site attempts to provide accurate descriptions and images of products. However, 
              we do not warrant that product descriptions, images, or other content are accurate, complete, 
              or error-free.
            </p>
          </div>
        </section>

        <section className="policy-section">
          <h2>11. Payment Methods</h2>
          <p>
            We accept payment through various methods including credit cards, debit cards, 
            PayPal, and other payment processors. All payment information is processed securely. 
            You warrant that you have the right to use the payment method you provide and that 
            the information you provide is accurate.
          </p>
          <p>
            We partner with Stripe and PayPal for payment processing. These third parties have 
            their own terms and conditions. By making a purchase, you agree to their terms.
          </p>
        </section>

        <section className="policy-section">
          <h2>12. Intellectual Property Rights</h2>
          <p>
            All content on the Site, including but not limited to text, graphics, logos, images, 
            and software, is the property of the Site or its content suppliers and is protected by 
            international copyright laws.
          </p>
          <p>
            Product descriptions and images provided by vendors remain the intellectual property of the vendors. 
            By listing a product on the Site, vendors grant the Site a non-exclusive license to display, 
            reproduce, and distribute the product information and images.
          </p>
        </section>

        <section className="policy-section">
          <h2>13. Prohibited Conduct</h2>
          <p>
            You agree not to engage in any of the following prohibited conduct:
          </p>
          <ul>
            <li>Violating any applicable laws or regulations</li>
            <li>Infringing upon intellectual property rights</li>
            <li>Transmitting viruses, malware, or any other malicious code</li>
            <li>Harassing, threatening, or abusing other users</li>
            <li>Posting false, misleading, or defamatory content</li>
            <li>Attempting to gain unauthorized access to the Site</li>
            <li>Collecting or tracking personal information of others without consent</li>
            <li>Engaging in spam or unsolicited commercial communications</li>
            <li>Impersonating another person or entity</li>
            <li>Engaging in fraudulent or deceptive practices</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>14. Third-Party Links</h2>
          <p>
            The Site may contain links to third-party websites. We are not responsible for the content, 
            accuracy, or practices of these third-party sites. Your use of third-party websites is at your own risk 
            and subject to their terms and conditions.
          </p>
        </section>

        <section className="policy-section">
          <h2>15. Termination</h2>
          <p>
            The Site may terminate or suspend your access at any time, for any reason, including for violation 
            of these Terms & Conditions or any applicable laws. Upon termination, you must cease all use of the Site.
          </p>
        </section>

        <section className="policy-section">
          <h2>16. Contact Information</h2>
          <p>
            If you have any questions or concerns regarding these Terms & Conditions, please contact us at:
          </p>
          <div className="contact-info">
            <p><strong>Email:</strong> <a href="mailto:mashaba.enterprise2025@gmail.com">mashaba.enterprise2025@gmail.com</a></p>
            <div className="website-logo">
              <img src="/logo.png" alt="Heritage Hub Logo" className="logo-image" />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default TermsConditions;
